import { z } from 'zod'

import {
  MaintenanceReviewerSchema,
  MaintenanceSourceParentSchema,
} from './maintenance-programs'

const MaintainerProgramSchema = z.object({
  executor: z.literal('maintainer').default('maintainer'),
  automationId: z.string().min(1),
  directive: z.string().min(1),
  routineKeys: z.array(z.string()).optional(),
  sourceTypes: z.array(z.string()).optional(),
  sourceParents: z.array(MaintenanceSourceParentSchema).optional(),
  memory: z.array(z.string()).optional(),
  reviewers: z.array(MaintenanceReviewerSchema).optional(),
  audienceUserIds: z.array(z.string()).optional(),
})

const ContradictionsProgramSchema = z.object({
  executor: z.literal('contradictions'),
  automationId: z.string().min(1),
})

/** Where a program run, which runs as no user, keeps its threads and
 *  checkpoints. The API stores no owner for it. Never a user id: nanoid ids
 *  have no dot. */
export const SYSTEM_RUN_OWNER = 'program.system'

export const AgentRunJobSchema = z.object({
  agentRunId: z.string().min(1),
  organizationId: z.string().min(1),
  /** Absent for a maintenance program run, which runs as no user. */
  ownerId: z.string().min(1).optional(),
  noteId: z.string().min(1).optional(),
  frequencyInDays: z.number().positive(),
  program: z
    .union([ContradictionsProgramSchema, MaintainerProgramSchema])
    .optional(),
})
export type AgentRunJob = z.infer<typeof AgentRunJobSchema>
export type MaintainerProgramRun = z.infer<typeof MaintainerProgramSchema>
